// extracted by mini-css-extract-plugin
export default {"cellText":"TableCell_cellText__+Emwk","filled":"TableCell_filled__7tuAa"};